import { Badge, DraftIcon, HideIcon, Tooltip } from "@hightouch/htui";

type Props = {
  size?: "sm" | "md";
};

export function DraftBadge({ size }: Props) {
  return (
    <Tooltip message="Draft">
      <Badge
        shape="circle"
        size={size}
        svgIcon={DraftIcon}
        aria-label="Draft"
      />
    </Tooltip>
  );
}

export function PrivateBadge({ size }: Props) {
  return (
    <Tooltip message="Private">
      <Badge
        shape="circle"
        size={size}
        svgIcon={HideIcon}
        aria-label="Private"
      />
    </Tooltip>
  );
}
